module.exports = __webpack_public_path__ + "img/1.2.3大数据工程师.7d4b6512.png";